import type { Data } from '@puckeditor/core';

/** Validates that a value looks like a Puck Data payload. */
export function isPuckData(value: unknown): value is Data {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const record = value as Record<string, unknown>;
  return Array.isArray(record.content) && typeof record.root === 'object' && record.root !== null;
}
